export default __webpack_public_path__ + "static/Heavy_Auto_Turret-f20c29094113afbafcf03dceb91e0408.png";